export enum INSPECTION_STATUSES {
  PREPARING = 'preparing',
  DRAFT = 'draft',
  QUEUED = 'queued',
  RUNNING = 'running',
  PENDING = 'pending',
  COMPLETE = 'complete',
  FINALIZING = 'finalizing',
  ERRORED = 'errored',
}

export default INSPECTION_STATUSES;
